import React from 'react';
import ReportFrame from '../ReportFrame';

export default class IobList extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reportParams = {};
    return (
      <div className='contentwrapper bg-white'>
        <ReportFrame
          reportName='IOB List'
          reportParams={reportParams}
          id='ioblist'
          name='IOBlist'
          title='IOB List'
        />
      </div>
    );
  }
}
